











































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import moment from 'moment-timezone'
import DateRangePicker from 'buefy-daterange-picker'

// mixins
import DateRangeMixin from '@/components/mixins/DateRangeMixin.vue'

// Models
import GeofenceModel from '@/_models/GeofenceModel'

// Helpers
import { NOTIFICATION_TYPE } from '@/_consts/NotificationType'
import { Constant } from '@/_services/constant'
import { Filter } from '@/_utils/filter'

// Components
import TablePagination from '@/components/shared/TablePagination.vue'
import LabelButtonInput from '@/components/common/buttons/LabelButtonInput.vue'
import GeofenceNotification from '@/components/notification/GeofenceNotification.vue'

// Types
type componentType = 'geofence' | 'monitor'

@Component({
  components: {
    TablePagination,
    DateRangePicker,
    LabelButtonInput,
  },
})
export default class NotificationPage extends Mixins(DateRangeMixin) {
  typeComponent: componentType = 'geofence'
  notificationCacheFilter = new Filter('noti-page-filter')
  geofenceCacheFilter = new Filter('geofence-noti-filter')
  typesAllow: string[] = ['geofence']
  componentSelected: any
  componentList = {
    geofence: GeofenceNotification,
  }

  seletedGeofence: GeofenceModel = new GeofenceModel()

  filterNotiType = {
    searchQuery: '',
    selectedFilter: 'name',
  }

  filterGeofence: any = {
    searchQuery: '',
    selectedFilter: 'name',
  }

  pageFilters: any = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'major',
    searchQuery: '',
    isCheckedRead: true,
    isCheckedUnread: true,
  }

  extendSearch = {
    user_ids: [],
    location: '',
  }

  numofPage: number = 1

  get currentUser() {
    return this.$store.state.authentication?.currentUser
  }

  get notificationFilter() {
    return NOTIFICATION_TYPE.filter(
      type => type.name.toString().toLowerCase().indexOf(this.filterNotiType.searchQuery.toLowerCase()) !== -1
    )
  }

  get notifications() {
    return this.$store.state.notifications.all.items
  }

  get totalData(): number {
    return this.$store.state.notifications.all.total
  }

  get geofences(): GeofenceModel[] {
    return this.$store.state.geofences.all.items
  }

  get filterGeofenceData() {
    return this.geofences.filter(
      geofence =>
        geofence.name.toString().toLowerCase().indexOf(this.filterGeofence.searchQuery.toLowerCase()) !== -1
    )
  }

  get statusSearch(): string {
    const isRead = this.pageFilters.isCheckedRead
    const isUnRead = this.pageFilters.isCheckedUnread

    if (isRead && !isUnRead) {
      return 'read'
    } else if (isUnRead && !isRead) {
      return 'unread'
    }

    return 'all'
  }

  get isLoading() {
    return this.$store.state.notifications.loading
  }

  get isDisableSearch() {
    return !this.filterNotiType.searchQuery || !this.filterGeofence.searchQuery || !this.seletedGeofence._id
  }

  @Watch('dateRange')
  dateRangeChanged(): void {
    if (this.isDisableSearch) {
      return
    }

    this.saveDaterange()
    this.getNotificationData()
  }

  @Watch('pageFilters.isCheckedRead')
  @Watch('pageFilters.isCheckedUnread')
  onCheckedStatusChange() {
    if (this.isDisableSearch) {
      return
    }

    this.getNotificationData()
  }

  handleSelectType(seleted) {
    if (!seleted) {
      return
    }

    this.typeComponent = seleted.name
  }

  handleSelectGeofence(seletedGeofence: GeofenceModel) {
    if (!seletedGeofence) {
      return
    }

    this.seletedGeofence = seletedGeofence

    this.resetFilter()
    this.getNotificationData()
  }

  onPagePagination(pageChange: any) {
    if (this.isDisableSearch) {
      return
    }
    this.getNotificationData()
  }

  parseDate(date: string) {
    return moment(date).format(Constant.DATE_TIME_FORMAT)
  }

  resetFilter() {
    this.extendSearch = {
      user_ids: [],
      location: '',
    }
  }

  getNotificationData() {
    const param = {
      type: this.typeComponent,
      date_from: moment(this.dateRange.startDate).format(Constant.DATE_FORMAT_QUERY),
      date_to: moment(this.dateRange.endDate).subtract(1, 'seconds').format(Constant.DATE_FORMAT_QUERY),
      gmt: -(new Date().getTimezoneOffset() / 60),
      id: this.seletedGeofence._id,
      page: this.pageFilters.currentPage,
      per_page: this.pageFilters.perPage,
      status: this.statusSearch,
      operator_id: this.currentUser._id,
      ...this.extendSearch,
    }

    this.$store.dispatch('notifications/getAll', param)
  }

  findGeofence(geofenceId?: string) {
    let geofence

    if (geofenceId) {
      geofence = this.geofences.find(geo => geo._id === geofenceId)
    } else if (this.filterGeofence.searchQuery) {
      geofence = this.geofences.find(geo => geo.name.includes(this.filterGeofence.searchQuery))
    }

    return geofence ? geofence : this.geofences[0]
  }

  async doGetGeofenceNotification(queries: any) {
    await this.$store.dispatch('geofences/getAll')
    if (!this.geofences.length) {
      return
    }

    const geofence = this.findGeofence(queries.geofence_id) as GeofenceModel
    if (geofence) {
      this.seletedGeofence = geofence
      this.filterGeofence.searchQuery = geofence?.name

      this.getNotificationData()
    }
  }

  async created() {
    /* tslint:disable-next-line */
    let { type, ...queries } = this.$route.query
    if (!type || !this.typesAllow.includes(type as string)) {
      type = 'geofence'
    }

    this.pageFilters = this.notificationCacheFilter.get(this.pageFilters)
    this.filterGeofence = this.geofenceCacheFilter.get(this.filterGeofence)

    this.filterNotiType.searchQuery = this.typeComponent = type as componentType
    this.componentSelected = this.componentList[`${this.typeComponent}`]

    switch (type) {
      case 'geofence':
        await this.doGetGeofenceNotification(queries)
        break

      default:
        break
    }
  }

  beforeDestroy() {
    this.notificationCacheFilter.save(this.pageFilters)
    this.geofenceCacheFilter.save(this.filterGeofence)
    this.$store.dispatch('resetAllModulesState', ['notifications'])
  }
}
